export enum EFreightForShipperStatus {
  DEFAULT = 'DEFAULT', // new, default value when object is created

  // PENDING = 'PENDING',

  ASSIGNED = 'ASSIGNED',
  ON_ROUTE = 'ON_ROUTE',
  FINISHED = 'FINISHED',

  OFFER_REQUESTED = 'OFFER_REQUESTED',
  OFFER_SENT = 'OFFER_SENT',

  CANCELLED = 'CANCELLED', // can view, can't modify

  DELETED = 'DELETED', // can't view, or error (is empty, is not valid,...)
}
